import { memo } from 'react'
import MultipleInputSkeleton from 'components/SkeletonView/MultipleInputSkeleton'

const PropertySkeleton = () => <MultipleInputSkeleton count={2} />

export default memo(PropertySkeleton)
